/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:55 2019-07-10
 */

import {Component} from 'vue-property-decorator'
import AuthConfigService from "./service/authConfigService"
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import { AuthConfigDOI } from './api/authConfigApi'

@Component
export default class AuthConfig extends BasicSearchPage<AuthConfigService, AuthConfigDOI.RowDataI, AuthConfigDOI.QueryRowDataParamsI> {
    @override
    renderHead(h) {
       return <div></div>
    }
    
    @override
    loadService () {
       this.service = new AuthConfigService(this)
    }
    
}
